module.exports = __webpack_public_path__ + "img/ydd.c0366b4d.png";